import { render, staticRenderFns } from "./RecentlyAdded.vue?vue&type=template&id=68aa01b2&scoped=true&"
import script from "./RecentlyAdded.vue?vue&type=script&lang=js&"
export * from "./RecentlyAdded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa01b2",
  null
  
)

export default component.exports